import { Block, LabelMedium, useStyletron } from "@mezo-org/mezo-clay"

import { SwappableToken } from "#/shared/types"
import { getCurrencySymbol } from "#/shared/utils"

type SwapModalRateProps = {
  sellToken: SwappableToken
  buyToken: SwappableToken
}

export default function SwapModalRate({
  sellToken,
  buyToken,
}: SwapModalRateProps) {
  const [css, theme] = useStyletron()

  return (
    <Block
      className={css({
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: `${theme.sizing.scale500} 0`,
      })}
    >
      <LabelMedium color={theme.colors.contentSecondary} as="span">
        Rate:
      </LabelMedium>
      <LabelMedium as="span">
        1 {getCurrencySymbol(sellToken)} ~ 100,000 {getCurrencySymbol(buyToken)}
      </LabelMedium>
    </Block>
  )
}
